import { getIntl } from '../../../utils/intl';

const permissionsIntl = getIntl('permissions-tree', {
    idsAndInfo: 'IDs & Info',
    medications: 'Medications',
    conditions: 'Conditions',
    allergies: 'Allergies',
    careTeam: 'Care Team',
    visits: 'Visits',
    notes: 'Notes',
    patientPortals: 'Connect Patient Portals',
    cloudCalendars: 'Cloud Calendars',
    settings: 'Settings',
    all: 'All',
    'medical-data': 'Health',
    connecting: 'Connecting',
    management: 'Managing',
    reports: 'Reports',
    files: 'Files',
    imaging: 'Imaging',
    procedures: 'Procedures',
    vaccinations: 'Vaccinations',
    labs: 'Labs',
    collaborators: 'Collaborators',
});

export { permissionsIntl };
